import Vue from 'vue'
import SignV from './SignModal'
import { save } from '@/api/Api'

const SignModal = Vue.extend(SignV)

SignV.install = function(data) {
  const instance = new SignModal({
    data
  }).$mount()
  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    const permissionList = this.$store.getters.roles.permissions
    const permission = permissionList.find((val) => {
      return val.permissionId === instance.router.name
    })
    const needSign = permission.actionList.findIndex((val) => {
      return val.no === instance.button && val.signable
    }) > -1
    if (!needSign) {
      instance.click()
    } else {
      instance.visible = true
    }
    const methodLog = { operator: instance.operator.name, host: '*', ip: '*', menu: instance.router.meta.title, method: instance.button, content: instance.reason }
    save('methodLogPersister', methodLog)
  })
}

export default SignV